import { inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: "root",
})
export class MomentService {
    private readonly translateService = inject(TranslateService);

    public get currentLocale() {
        const currentLang = this.translateService.getCurrentLang();

        if (currentLang === "nl") {
            return "nl-BE";
        }
        if (currentLang === "fr") {
            return "fr";
        }
        if (currentLang === "de") {
            return "de";
        }
        if (currentLang === "sv") {
            return "sv";
        }
        if (currentLang === "no") {
            return "nb";
        }

        return "en-GB";
    }
}
